import { Bulb, Height, Racket, Team } from "../../../shared/assets/svg";

export const advantages = [
  {
    icon: <Height />,
    description: 'Компания динамичного роста',
  },
  {
    icon: <Bulb />,
    description: <>Амбициозные и&nbsp;интересные задачи</>,
  },
  {
    icon: <Racket />,
    description: 'Яркая корпоративная жизнь',
  },
  {
    icon: <Team />,
    description: <>Работа в&nbsp;команде профессионалов</>,
  },
]